import { MenuItem, Typography, Box, Grid, useMediaQuery, IconButton, CircularProgress, Button } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Mixpanel } from '../mixpanel';
import { BodyMeasCompleteForClothingType, BodyMeasurements, CalculateClothBodyMeasurementsFromBodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingType, FitType, GetKey2CategoryClothingSizeMeasurementValues, RoundClothingMeasurementsToHalfPoint, GetChangedClothingMeasurementsFromBodyMeasurementsUpdate, BodyFitTypeDisplayString, getBodyCardFitFamily } from 'common-ts/dist/models/UserMeasurements';
import { getCurrentSelectedMeasurement, getMeasurementObjectFromRegularSize, postClothingMeasurementPreference, saveLocallyClothingMeasurementPreference, } from '../redux/MeasurementsRedux';
import { openOverlayCreateMeasWithInitialization } from '../redux/UIOverlayMeasurementCreateViewRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import ProductOnUser from 'common-ts/dist/models/Product';
import { closeOverlayAndReset as closeOverlayAndResetSelection } from '../redux/UIOverlayMeasurementSelectionViewRedux';
import React, { useEffect } from 'react';
import { RegularSizeValue, SizeType } from 'common-ts/dist/models/Cart';
import { formatTimestampSize } from './PageProductDetailSizeSelection';
import EditIcon from '@material-ui/icons/Edit';
import { closeOverlayAndReset as closeOverlayAndResetUnivSizeCreateView, setValues as setValuesUnivSizeCreateView, openOverlay as openOverlayUnivSizeCreateView } from '../redux/UIOverlayUniversalSizeCreateMeasRedux';
import { closeOverlayAndReset as closeOverlayAndResetEditView, openOverlay as openOverlayEditView, setValues as setValuesEditView } from '../redux/UIOverlayMeasurementEditViewRedux';
import { setPilihUkuranDataValues } from '../redux/UIOverlayMeasurementSelectionViewRedux';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { openOverlay as openOverlayPersonalSizeDetail, setKey2CategoryResultShown } from '../redux/UIOverlayPersonalSizeRedux';
import { ClothingMeasurementDetailPanel, convertTimestampToDisplayString, getClothingMeasurementsRuler, getClothingMeasurementsSubtext } from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
// import OverlayComponentCanvas from './OverlayComponentCanvasFitAnimation';
import { openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';

import { closeOverlayAndReset as closeOverlayAndResetPersonal, updateCurrentScreen as updateCurrentScreenPersonal } from '../redux/UIOverlayPersonalSizeRedux';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  sizeOptionsBox: {
    // padding: "0px 10px 0px 10px",
  },
  sizeOptionsBoxBadan: {
    marginBottom: '30px'
  },
  sizeOptionsBoxBadanImage: {
    width: "100%",
    objectFit: "cover"
  },
  sizeOptionsBoxBadanCardBox: {
    position: 'absolute', 
    top: '1.85vw', 
    left: '2vw',
    [theme.breakpoints.up('sm')]: {
      top: '24px',
      left: '14px',
    }
  },
  sizeOptionsBoxBadanGantiBox: { 
    position: 'absolute', 
    top: '3.6vw', 
    right: '3.5vw',
    [theme.breakpoints.up('sm')]: {
      top: '15px',
      right: '15px',
    }
  },
  sizeOptionsBoxBadanPakaiBox: { 
    position: 'absolute', 
    bottom: '3.7vw', 
    right: '3.5vw',
    [theme.breakpoints.up('sm')]: {
      bottom: '15px',
      right: '15px',
    }
  },
  sizeOptionsBoxBadanGantiText: {
    fontSize: '2.4vw',
    fontWeight: 500,
    color: '#232323',
    padding: '1.2vw 2.6vw 0.5vw 2.6vw',
    borderRadius: '4vw',
    border: '0.7px solid #232323',
    [theme.breakpoints.up('sm')]: {
      fontSize: '11px',
      padding: '6px 10px 4px 10px',
    }
  },
  sizeOptionsBoxBadanGantiText2: {
    fontSize: '3vw',
    fontWeight: 500,
    // lineHeight: '3.6vw',
    letterSpacing: '0.1vw',
    color: '#232323',
    padding: '1.8vw 2.3vw 0.8vw 2.3vw',
    borderRadius: '4vw',
    border: '0.7px solid #232323',
    [theme.breakpoints.up('sm')]: {
      fontSize: '11px',
      letterSpacing: '0.6px',
      padding: '6px 10px 4px 10px',
    }
  },
  sizeOptionsBoxBadanNameBox: {
    margin: '14px',
    // height: '16vw',
    [theme.breakpoints.up('sm')]: {
      // height: '120px',
    }
  },
  sizeOptionsBoxBadanNameTextHeader: {
    fontSize: '2vw',
    letterSpacing: '0.05vw',
    fontWeight: 600,
    color: '#787878',
    marginBottom: '0.3vw',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      fontSize: '8px',
      letterSpacing: '0.06px',
    }
  },
  sizeOptionsBoxBadanNameTextOnly: {
    fontSize: '5.6vw',
    letterSpacing: '0.1vw',
    fontWeight: 600,
    color: '#121212',
    marginBottom: '0.5vw',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
      letterSpacing: '0.14px',
    }
  },
  sizeOptionsBoxBadanNameText: {
    fontSize: '4vw',
    letterSpacing: '0.1vw',
    fontWeight: 600,
    color: '#121212',
    marginBottom: '0.5vw',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
      letterSpacing: '0.14px',
    }
  },
  sizeOptionsBoxBadanTanggalText: {
    fontSize: '2.2vw',
    fontStyle: 'italic',
    fontWeight: 300,
    color: '#565656',
    [theme.breakpoints.up('sm')]: {
      fontSize: '11px',
    }
  },
  sizeOptionsBoxBadanTinggiBeratText: {
    fontSize: '2vw',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '0.2vw',
    [theme.breakpoints.up('sm')]: {
      fontSize: '15px',
    }
  },
  sizeOptionsBoxBadanTinggiBeratValueText: {
    fontSize: '3.6vw',
    fontWeight: 300,
    color: '#ffffff',
    [theme.breakpoints.up('sm')]: {
      fontSize: '26px',
    }
  },
  sizeOptionsBoxBaju: {
    marginBottom: '50px'
  },
  sizeOptionsBoxSegmentBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
    padding: "0px 10px 0px 10px",
  },
  sizeOptionsBoxSegmentTitle: {
    fontSize: '3.2vw',
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    }
  },
  sizeOptionsBoxSegmentSubtext: {
    fontSize: '2.7vw',
    letterSpacing: '0.6px',
    fontWeight: 300,
    color: "#a3a3a3",
    marginLeft: '10px',
    paddingBottom: '2px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '11px',
    }
  },
  productDetailRoot: {
  },
  productDetailNav: {
    paddingLeft: '20px',
    paddingRight: '30px',
    paddingTop: '0px',
    marginTop: '0px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '10px',
      marginTop: '0px',
    },
  },
  productDetailMain: { // ALLBIRDS is 18px left and right, 24px to leftmost image
    // paddingLeft: '24px',
    // paddingRight: '30px',
  },
  otherProductRecs: {
    display: 'block',
  },
  sectionDesktopAndMobile: {
    display: 'flex',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  cartContentImageContainer: { // ALLBIRDS is 6px
    width: 'auto',
    padding: '0px 20px 0px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 0px 0px 0px',
    }
  },
  cartContentImage: {
    cursor: 'pointer',
  },
  stickyDetailContainer: {
    position: 'sticky',
    top: '40px',
  },
  productName: {
    marginBottom: '6px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '6px',
    },
  },
  productPrice: {
    marginBottom: '24px',
  },
  productLeftInStock: {
    marginBottom: '16px',
  },
  productDescription: {
    marginBottom: '28px',
    marginTop: "20px",
  },
  ukuranRegulerBox: {
    marginBottom: '28px',
    marginTop: "20px",
    position: "relative",
  },
  ukuranRegulerBoxSizeChartLink: {
    position: "absolute",
    right: "0",
    top: "2px",
    fontSize: "11px",
    color: "#5e5e5e",
    textDecoration: "underline #5e5e5e solid 1px",
    cursor: "pointer",
    '-webkit-tap-highlight-color': 'transparent',
  },
  ukuranRegulerSizeTextBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "1vw",
    paddingLeft: "0.4vw",
    paddingRight: "0.4vw",
    [theme.breakpoints.down('xs')]: {
      marginTop: "4vw",
    }
  },
  ukuranRegulerSizeTextAda: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#232323",
    [theme.breakpoints.down('xs')]: {
      fontSize: "15px",
    }
  },
  ukuranRegulerSizeTextHabis: {
    fontSize: "12px",
    fontWeight: 300,
    color: "#7e7e7e",
    textDecoration: "line-through #7e7e7e solid 1px",
    [theme.breakpoints.down('xs')]: {
      fontSize: "15px",
    }
  },
  addToCartButton: {
    marginTop: '40px',
    marginBottom: '24px',
    justifyContent: 'center',
  },
  addToCartButtonText: {
    fontSize: '0.8rem', // 16px is 1 rem. 0.8 rem is 12.8px
    fontWeight: 600,
    letterSpacing: "0.03rem",
  },
  accordionStyle: {
    margin: '4px 0px !important',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  panelSummary: {
    "&.Mui-expanded": {
      minHeight: 0
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "auto"
    }
  },
  panelSummaryText: {
    "&:hover": {
      fontWeight: theme.typography.fontWeightBold as number,
      fontSize: '15px',
      textDecoration: 'underline',
    },
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '15px',
  },
  panelContentText: {
    fontWeight: theme.typography.fontWeightLight as number,
    fontSize: '15px',
    paddingLeft: '10px',
  },
  productNameText: {
    fontSize: '30px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  },
  priceBox: {
    display: 'flex',
    alignItems: 'center',
  },
  productPriceText: {
    fontWeight: 'normal',
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  productPriceTextDiscount: {
    fontWeight: 'normal',
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  productPriceTextDiscountStrikeThrough: {
    fontWeight: 'normal',
    color: 'red',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '10px',
    marginTop: '2px',
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
    textDecoration: 'line-through',
  },
  productLeftInStockText: {
    fontWeight: 600,
    color: '#2a2a2a',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  productDescriptionText: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    marginBottom: '20px',
  },
  pilihUkuranSubtext: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    marginBottom: '8px',
  },
  productSubtitle: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '14px',
    marginBottom: '6px',
  },
  talentInfoText: {
    color: '#343434',
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "14px",
  },
  restockInfoText: {
    color: '#343434',
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "10px",
  },
  restockInfoTextHighlight: {
    color: '#1f1f1f',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "10px",
  },
  restockInfoTextIcon: {
    fontSize: '13px',
    marginRight: "9px",
  },
  chooseSizeButton: {
    width: "100%",
    paddingLeft: '20px',
    paddingRight: '24px',
    paddingTop: '9px',
    paddingBottom: '9px',
    backgroundColor: '#f1f1f1',
    marginTop: '6px',
    marginBottom: '12px',
    '&:hover': {
      backgroundColor: '#e9e9e9',
      borderColor: '#0062cc',
    },
    display: "flex",
    justifyContent: "space-between",
  },
  gantiUkuranText: {
    fontSize: "10px",
    textWrap: "nowrap",
    fontWeight: 500,
    textDecoration: "underline #121212 solid 1px",
    textUnderlineOffset: "3px",
    paddingLeft: "6px",
  },
  measurementMenuItemBody: {
    position: 'relative',
  },
  measurementMenuItemSelected: {
    padding: '14px 16px 14px 16px',
    marginBottom: '10px',
    borderRadius: '20px',
    position: 'relative',

    border: '1px solid #676767',

    [theme.breakpoints.only('xs')]: {
      padding: '3.2vw 3.4vw 3.2vw 3.4vw',
      borderRadius: '5vw',
    }
  },
  measurementMenuItem: {
    padding: '14px 16px 14px 16px',
    marginBottom: '10px',
    borderRadius: '20px',
    position: 'relative',

    border: '1px solid #ebebeb',

    [theme.breakpoints.only('xs')]: {
      padding: '3.2vw 3.4vw 3.2vw 3.4vw',
      borderRadius: '5vw',
    },
  },
  measurementMenuItemCheck: {
    width: '20px',
    position: 'absolute',
    top: '-5px',
    right: '-5px'
  },
  measurementMenuItemMainText: {
    fontSize: '12px',
    letterSpacing: '0.3px',
    fontWeight: 600,
    color: '#232323',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.only('xs')]: {
      fontSize: '3.1vw',
    }
  },
  measurementMenuItemDetailTitleText: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#232323',
    marginBottom: '3px',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.only('xs')]: {
      fontSize: '2.3vw',
    }
  },
  measurementMenuItemDetailContentText: {
    fontSize: '10px',
    fontWeight: 300,
    color: '#232323',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.only('xs')]: {
      fontSize: '2.3vw',
    }
  },
  measurementMenuItemBuatUkuranText: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 600,
    paddingTop: '2px',
    paddingLeft: '6px',
    color: '#232323'
  },
  selectedMarkerBody: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    top: '0px',
    right: '0px',
    backgroundColor: 'green'
  },
  selectedMarker: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    top: '0px',
    right: '0px',
    backgroundColor: 'green'
  },
  sizeText: {
    color: '#3b3b3b',
    fontSize: '12px',
    textAlign: "left",
  },
  sizeTextNewSize: {
    color: '#3b3b3b',
    fontSize: '15px',
    marginLeft: '10px',
    marginTop: '1px',
  },
  mobileViewImageCarouselContainer: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  mobileViewImageCarousel: {
    // float: 'left',
  },
  cartCarouselImageContainer: {
    padding: '0px',
  },
  cartCarouselImage: {
    width: '100%',
    objectFit: 'cover',
    aspectRatio: '2/3',
    marginBottom: '36px',
  },
  image: {
    width: '100%',
    objectFit: 'cover',
    aspectRatio: '2/3',
  },
  cartCarouselContainer: {
    width: '100%',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    marginBottom: '16px',
    position: "relative",
  },
  sisaBox: {
    backgroundColor: "#ff1e1e",
    textAlign: "center",
    position: "absolute",
    bottom: "1vw",
    left: "1vw",
    width: "6vw",
    borderRadius: "1.3vw",
    [theme.breakpoints.down('xs')]: {
      bottom: "15.4vw",
      left: "3.4vw",
      width: "20vw",
      borderRadius: "8vw",
    },
  },
  sisaText: {
    fontSize: "1.3vw",
    paddingTop: "0.3vw",
    color: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      fontSize: "4vw",
      paddingTop: "1.2vw",
    },
  },
  sisaBoxInDetail: {
    backgroundColor: "#ff1e1e",
    textAlign: "center",
    width: "6vw",
    borderRadius: "1.3vw",
    [theme.breakpoints.down('xs')]: {
      display: "none",
    },
  },
  sisaTextInDetail: {
    fontSize: "1.3vw",
    paddingTop: "0.3vw",
    color: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      display: "none",
    },
  },
  indicatorItemSelected: {
    display: 'inline-block',
    background: '#000',
    width: 8,
    height: 8,
    margin: '0px 4px',
    borderRadius: '50%',
  },
  indicatorItem: {
    display: 'inline-block',
    background: '#999',
    width: 8,
    height: 8,
    margin: '0px 4px',
    borderRadius: '50%',
  },
  limitedStockBubbleBox: {
    width: "fit-content",
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "3px",
    borderRadius: "12px",
    border: "1px solid black",
    marginBottom: "28px"
  },
  limitedStockBubbleText: {
    fontFamily: "OakesGrotesk",
    fontWeight: 500,
    fontSize: "11px",
    letterSpacing: "0.5px",
  },
  starsElementContainer: {
    display: 'flex',
    marginBottom: '6px',
  },
  starsDescriptionText: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '10px',
    marginTop: '4px',
  },
  productRating: {
    marginBottom: '16px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '14px',
    },
  },
  reviewsSegment: {
    margin: '0px 0px 30px 0px',
  },
  reviewsSegmentTitle: {
    margin: '40px 20px 20px 20px',
    fontWeight: theme.typography.fontWeightBold as number,
    [theme.breakpoints.up('md')]: {
      margin: '0px 40px 10px 50px',
    }
  },
  reviewsSegmentBody: {
    marginTop: '18px',
    marginBottom: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    [theme.breakpoints.up('md')]: {
      marginTop: '18px',
      marginBottom: '20px',
      marginLeft: '60px',
      marginRight: '60px',
    },
  }, 
  reviewItem: {
    margin: '0px 0px 16px 0px',
    padding: '8px 2px 24px 2px',
    width: 'auto',
    borderBottom: "1px solid #dedede",

    display: 'flex',
    flexDirection: 'row',

    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 22px 0px',
      padding: '6px 4px 28px 4px',
    },
  },
  reviewItemNew: {
    margin: '16px 10px',
    padding: '20px 20px',
    width: 'auto',
    cursor: 'pointer',
  },
  reviewDisplayPicture: {
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    padding: '10px',
    margin: '8px 18px 0px 6px',

    backgroundColor: '#d5d5d5',
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  reviewDisplayText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '20px',
    color: '#fff',
    marginTop: '0px',
    width: '30px' // Set to equal to display picture size
  },
  reviewItemBoxDescription: {

  },
  reviewItemBox1: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "5px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "6px",
    },
  },
  reviewItemIsVerifiedText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '11px',
    color: '#7A7A7A',
    paddingLeft: '1px',
    marginLeft: '10px', 
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
    },
  },
  reviewItemName: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '15px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
    },
  },
  reviewItemBox2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: "5px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "6px",
    },
    // [theme.breakpoints.down('sm')]: {
    //   flexDirection: 'column',
    // },
  },
  reviewItemDateAndPlaceText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '11px',
    color: "#6c6c6c",
    marginBottom: '12px', 
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  },
  reviewItemHeadline: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '15px',
    paddingLeft: '2px',
    paddingTop: '1px', 
    marginLeft: '6px', 
    marginBottom: '6px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      paddingTop: '1px', 
      marginLeft: '6px', 
    },
  },
  reviewItemComment: {
    fontFamily: 'Inter',
    fontWeight: 300,
    fontSize: '15px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  newReviewIcon: {
    marginLeft: '10px',
    marginBottom: '-4px'
  },
  starFilled: {
    color: '#FFA41C',
    marginLeft: '-3px',
    marginRight: '3px',
    [theme.breakpoints.down('sm')]: {
      width: '24px',
      marginLeft: '-3px',
      marginRight: '3px',
    },
  },
  starEmpty: {
    color: '#d8d8d8',
    marginLeft: '-3px',
    marginRight: '3px',
    [theme.breakpoints.down('sm')]: {
      width: '24px',
    },
  },
  roundedButtonSelected: {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '400px',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '2px',
    paddingBottom: '2px',
    margin: '4px 8px 12px 0px',
    fontWeight: 600,
    fontSize: '12px',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
    },
    border: '1px solid black',
  },
  roundedButton: {
    // color: 'white',
    borderRadius: '400px',
    color: '#727272',
    borderColor: '#727272',
    borderWidth: '1px',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '2px',
    paddingBottom: '2px',
    margin: '4px 8px 12px 0px',
    fontWeight: 600,
    fontSize: '12px',
  },
  imageBoxWidth: {
    width: '30vw',
  },
  sectionPhoto: {
    margin: '0',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    flexGrow: 0,
    maxWidth: '70%',
    flexBasis: '70%',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  sectionDescription: {
    margin: '0',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    flexGrow: 0,
    maxWidth: '30%',
    flexBasis: '30%',
    paddingLeft: '26px',
    paddingRight: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  svgContentFullWidthDesktop: {
    marginTop: "3.3vw",
    marginBottom: "1.2vw",
    width: '100%',
  },
  svgContentFullWidthMobile: {
    width: '100%',
    marginTop: "16px",
  },
  sizeOptionsBoxDetailIconButton: {
    border: '1px solid #969696',
    borderRadius: '30px',
    color: '#000',
    padding: '1.2vw 2.4vw',
    [theme.breakpoints.up('sm')]: {
      padding: '5px 10px 5px 10px',
    }
  },
  sizeOptionsBoxDetailIconImg: {
    width: '4.1vw',
    margin: '-0.5vw',
    [theme.breakpoints.up('sm')]: {
      width: '16px',
      margin: '-2px',
    }
  },
  sizeOptionsBoxDetailText: {
    fontWeight: 500,
    letterSpacing: 0.5,
    paddingTop: '2px',
    fontSize: '2.1vw', // 9px -> 3px is 0.8vw
    [theme.breakpoints.up('sm')]: {
      fontSize: '9px',
      paddingTop: '2px',
    }
  },
  sizeOptionsBoxEditIconButton: {
    border: '1px solid #969696',
    borderRadius: '40px',
    color: '#000',
    padding: '1.5vw 1.5vw',
    [theme.breakpoints.up('sm')]: {
      padding: '5px 7px 5px 7px',
    }
  },
  sizeOptionsBoxEditText: {
    fontWeight: 500,
    paddingTop: '2px',
    fontSize: '2.4vw', // 9px -> 3px is 0.8vw
    [theme.breakpoints.up('sm')]: {
      fontSize: '10px',
      paddingTop: '2px',
    }
  }
}),
);

interface UkuranBadanCardProps {
  nama: string
  width: string
  fontSize?: string
}

export function UkuranBadanCardMini({nama, width, fontSize}: UkuranBadanCardProps) {
  return (
    <Box style={{
      width: width,
      position: 'relative',
    }}>
      <img 
      src={"https://studiosclo.uk/general/Card_Plain.png"} 
      alt="measkit-img"
      style={{
        width: "100%",
        objectFit: "cover"
      }}
      />
      <Typography style={{
        color: '#cfcfcf',
        fontSize: fontSize ?? `calc(${width}*0.07)`,
        position: 'absolute',
        left: '13%',
        top: '44%',
      }}>
        {nama}
      </Typography>
    </Box>
  )
}

interface UkuranBadanCardFullProps {
  nama: string
  height: string
  weight: string
  bodyType: string
  dibuatPada: string
  width: string
}

export function UkuranBadanCardFull({nama, height, weight, bodyType, dibuatPada, width}: UkuranBadanCardFullProps) {
  return (
    <Box style={{
      width: width,
      position: 'relative',
    }}>
      <img 
      src={"https://studiosclo.uk/general/Card_Plain_Large.png"} 
      alt="measkit-img"
      style={{
        width: "100%",
        objectFit: "cover"
      }}
      />
      <Typography style={{
        color: '#cfcfcf',
        fontSize: `calc(${width}*0.07)`,
        position: 'absolute',
        left: '13%',
        top: '44%',
      }}>
        {nama}
      </Typography>
      {/* <Typography style={{
        color: '#cfcfcf',
        fontSize: `calc(${width}*0.035)`,
        position: 'absolute',
        left: '13%',
        top: '67%',
      }}>
        {height}
      </Typography>
      <Typography style={{
        color: '#cfcfcf',
        fontSize: `calc(${width}*0.035)`,
        position: 'absolute',
        left: '36%',
        top: '67%',
      }}>
        {weight}
      </Typography>
      <Typography style={{
        color: '#cfcfcf',
        fontSize: `calc(${width}*0.035)`,
        position: 'absolute',
        left: '13%',
        top: '58%',
      }}>
        {bodyType}
      </Typography> */}
      <Typography style={{
        color: '#cfcfcf',
        fontSize: `calc(${width}*0.035)`,
        position: 'absolute',
        left: '13%',
        top: '77%',
      }}>
        {dibuatPada}
      </Typography>
    </Box>
  )
}

export function UkuranBadanSegment({clothingType, fitType, productDetail, singleSelectedBodyMeasurementCreationDateTime, singleSelectedBodyMeasurement, disableActions, closeParentFunction, useInstantATCView, useZeroInstallView, useZeroInstallInformation, productPurchaseStage, handleInstantATCViewPakai} : {
  clothingType: ClothingType,
  fitType: FitType,
  singleSelectedBodyMeasurement: any,
  singleSelectedBodyMeasurementCreationDateTime: string,
  productDetail?: any,
  disableActions?: boolean,
  closeParentFunction?: () => void,
  useZeroInstallView?: boolean,
  useZeroInstallInformation?: any,
  useInstantATCView?: boolean,
  productPurchaseStage?: string,
  handleInstantATCViewPakai?: () => void,
}) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  
  // STATE USED ONLY FOR INSTANT VIEW, FOR MINIMIZATION
  const tailorString = singleSelectedBodyMeasurement.tailorString;
  const [displayTierStage, setDisplayTierStage] = React.useState<string>('1-minimized'); // 1-minimized or 2-complete

  const openMeasDetail = () => {
    if (closeParentFunction) {
      closeParentFunction();
    }

    dispatch(setKey2CategoryResultShown(clothingType + '-' + fitType));
    dispatch(openOverlayPersonalSizeDetail());
    dispatch(updateCurrentScreenPersonal("ukuranPersonalCurrentHasilBaju"));
  }
  const openMeasDetailEdit = () => {
    if (closeParentFunction) {
      closeParentFunction();
    }

    dispatch(setKey2CategoryResultShown(clothingType + '-' + fitType));
    dispatch(openOverlayPersonalSizeDetail());
    dispatch(updateCurrentScreenPersonal("ukuranPersonalCurrentEdit"));
  }

  if (useInstantATCView || useZeroInstallView) {
    const currentRawClothingMeas = CalculateClothingMeasurementsFromBodyMeasurements(clothingType, fitType, singleSelectedBodyMeasurement.adjustedMeasurements, RegularSizeValue.L);
    const currentClothingMeas = RoundClothingMeasurementsToHalfPoint(currentRawClothingMeas);
    const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(clothingType, fitType, false);
    const subtextDict = getClothingMeasurementsSubtext(clothingType, key2ClothSizeValues, currentClothingMeas);
    const sizeRulerDict = getClothingMeasurementsRuler(clothingType, key2ClothSizeValues, currentRawClothingMeas);

    // WE USE BODY BASED RULER & SUBTEXT (THE C VALUES ARE COMPARED TO C_BODY VALUES) TO MAINTAIN CONSISTENCY
    const currentRawClothingMeasBody = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, singleSelectedBodyMeasurement.adjustedMeasurements, RegularSizeValue.L);
    const currentUpdatedClothingMeasBody = GetChangedClothingMeasurementsFromBodyMeasurementsUpdate(singleSelectedBodyMeasurement?.lastUpdatedMeasurementsList ?? {}, singleSelectedBodyMeasurement?.adjustedMeasurements ?? {}, ClothingType.Body);
    const currentRawBodyMeas = (singleSelectedBodyMeasurement?.adjustedMeasurements ?? {});
    const currentClothingMeasBody = RoundClothingMeasurementsToHalfPoint(currentRawClothingMeasBody);
    const key2ClothSizeValuesBody = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Body, FitType.RegularFit, false);
    const subtextDictBody = getClothingMeasurementsSubtext(ClothingType.Body, key2ClothSizeValuesBody, currentClothingMeasBody);
    const sizeRulerDictBody = getClothingMeasurementsRuler(ClothingType.Body, key2ClothSizeValuesBody, currentRawClothingMeasBody);

    const detailHeaderClickFunction = useInstantATCView ? openMeasDetail : () => {
      dispatch(openUniversalSizeOverlay({ productOnUser: productDetail, flowVariant: 'productDetailInstant', flowInputVariables: {
        // clothingType: clothingType,
        // fitType: fitType,
        // clothMeasValue: singleSelectedBodyMeasurement?.adjustedMeasurements,
        // clothMeasValueNoAdjustment: true,
      }}));
    };
    const detailCmClickFunction = useInstantATCView ? () => {
      // SHOW SPECIFIC MEASUREMENT
      dispatch(closeOverlayAndResetEditView());
      dispatch(setValuesEditView({
        overlayType: 'view',
        clothingType: clothingType,
        fitType: fitType,
        isFullScreen: false,
        currentMeasurementObject: singleSelectedBodyMeasurement,
        productDetail: productDetail,
        personalFitResultViewType: 'edit',
        handlePakaiUkuran: (productPurchaseStage === "ADD_TO_CART" ? handleInstantATCViewPakai : undefined),
      }))
      dispatch(openOverlayEditView());
    } : () => {
      dispatch(openUniversalSizeOverlay({ productOnUser: productDetail, flowVariant: 'productDetailInstant', flowInputVariables: {
        clothingType: clothingType,
        fitType: fitType,
        clothMeasValue: singleSelectedBodyMeasurement?.adjustedMeasurements,
        // clothMeasValueNoAdjustment: true,
      }}));
    };
    const onEditClick = useInstantATCView ? openMeasDetailEdit : () => {
      dispatch(openUniversalSizeOverlay({ productOnUser: productDetail, flowVariant: 'productDetailInstant', flowInputVariables: {
        clothingType: clothingType,
        fitType: fitType,
        clothMeasValue: singleSelectedBodyMeasurement?.adjustedMeasurements,
        // clothMeasValueNoAdjustment: true,
      }}));
    };
    const onUseClick = useInstantATCView ? (productPurchaseStage === "ADD_TO_CART" ? handleInstantATCViewPakai : undefined) : () => {
      dispatch(openUniversalSizeOverlay({ productOnUser: productDetail, flowVariant: 'productDetailInstant', flowInputVariables: {
        clothingType: clothingType,
        fitType: fitType,
        clothMeasValue: singleSelectedBodyMeasurement?.adjustedMeasurements,
        clothMeasValueNoAdjustment: true,
      }}));
    };

    return (
    <Box style={{
      paddingTop: '66px',
      paddingBottom: '10px',
      marginTop: '50px',
      position: 'relative',
      border: '1px solid rgb(229 229 229)',
      borderRadius: '20px',
    }}>
    <Box style={{
      padding: '0px 8px',
      position: 'absolute',
      top: '-40px',
      width: '-webkit-fill-available',
    }}>
    <Box
      style={{
        position: 'relative',
        // aspectRatio: '3.3',
        borderRadius: '13px',
        backgroundColor: '#ffffff',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 7px 0px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: isMdOrUp ? '12px 12px 4px 12px' : '2.4vw 2.2vw 0.4vw 2.2vw'
      }}
      onClick={detailHeaderClickFunction}
    >
      {
        useInstantATCView ? 
        <>
        <Box onClick={detailHeaderClickFunction}>
          <UkuranBadanCardMini width={ isMdOrUp ? '60px' : '13vw' } fontSize={ isMdOrUp ? undefined : '1.1vw' } nama={singleSelectedBodyMeasurement?.nama ? singleSelectedBodyMeasurement.nama : 'User'}/>
        </Box>
        <Grid container style={{ width: '80%' }} onClick={detailHeaderClickFunction}>
            <Grid item xs={12} className={classes.sizeOptionsBoxBadanNameBox} style={{margin: '5px 6px 0px 1px', position: 'relative'}}>
              <Box style={{display: 'flex', alignItems: 'center', marginBottom: '4px'}}>
                <Typography style={{
                  fontSize: '6px', fontWeight: 500, letterSpacing: '0.5px',
                  color: '#fff', backgroundColor: '#121212', padding: '3px 8px 2px', borderRadius: '10px',
                  width: 'fit-content', position: 'relative'
                }}>
                  PERSONAL FIT
                </Typography>
                <Typography style={{
                  fontSize: '8px', fontWeight: 500, letterSpacing: '0.4px', marginLeft: '5px', paddingTop: '2px'
                }}>
                  UNTUK SEMUA PRODUK {BodyFitTypeDisplayString[getBodyCardFitFamily(singleSelectedBodyMeasurement)].toUpperCase()}
                </Typography>
              </Box>
              <Typography className={classes.sizeOptionsBoxBadanNameTextOnly} style={{marginTop: '7px'}}>{singleSelectedBodyMeasurement?.nama ? 
              singleSelectedBodyMeasurement.nama.substring(0, 1).toUpperCase() + singleSelectedBodyMeasurement.nama.substring(1).toLowerCase() : 'User'}</Typography>
            </Grid>
        </Grid>
        </>:
        <>
        <Box style={{ width: '20%' }} onClick={detailHeaderClickFunction}>
          <img src={useZeroInstallInformation.productImage} style={{width: '100%'}} alt={'alt-prod-1'}/>
        </Box>
        <Grid container style={{ width: '80%' }} onClick={detailHeaderClickFunction}>
          <Grid item xs={12} className={classes.sizeOptionsBoxBadanNameBox} style={{margin: '8px 14px'}}>
            <Typography style={{
              fontSize: '8px', fontWeight: 500, letterSpacing: '0.5px',
              width: 'fit-content', marginBottom: '4px'
            }}>PAKAI UKURAN CUSTOM</Typography>
            <Typography className={classes.sizeOptionsBoxBadanNameTextOnly} style={{fontSize: '14px'}}>{useZeroInstallInformation.productName}</Typography>
            <Typography className={classes.sizeOptionsBoxBadanTanggalText}>
              DARI PEMBELIAN SEBELUMNYA
            </Typography>
          </Grid>
        </Grid>
        </>
      }
    </Box>
    </Box>
    <Box>
      <Grid container>
        {/* <Grid item xs={5} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}} key={'displ-' + clothingType + fitType}>
          <OverlayComponentCanvas
            clothingType={clothingType}
            fitType={fitType}
            putAtTop={false}
            incrementTogether={true}
            goalFit={currentClothingMeas}
            canvasManualHeight={'90%'}
            drawGuidelinesData={{
              lastChangedMeasurement: 'saf',
              lastChangedMeasurementName: '',
              guidelineDisplayRange: 2,
              sizeMeasurementValues: [],
              sizeMeasurementNames: []
            }}
          />
          {
            displayTierStage === '2-complete' ?
            <Typography style={{fontSize: '7.6px', letterSpacing: '0.1px', margin: '0px 0px 9px', textDecoration: 'underline', textUnderlineOffset: '3px', width: '100%', textAlign: 'center'}} 
            onClick={detailCmClickFunction}>+ LIHAT DETAIL CM</Typography>:
            null
          }
        </Grid> */}
        <Grid item xs={12} onClick={detailCmClickFunction}>
          <Box style={{margin: '9px -2px 4px 15px'}}>
          <ClothingMeasurementDetailPanel
            clothingType={ClothingType.Body}
            fitType={FitType.RegularFit}
            allowEditing={false}
            currentClothingMeas={currentClothingMeasBody}
            currentClothingMeasSubtextDict={subtextDictBody}
            currentClothingMeasUpdatedDict={currentUpdatedClothingMeasBody}
            currentBodyMeasRawValue={currentRawBodyMeas}
            currentlyFetchingAvailability={false}
            isMinimized={true}
            isSizeWheel={true}
            sizeWheelDict={sizeRulerDictBody}
            useInstantATCView={true}
            reductionMode={true}
            instantAtcViewMinimized={'1-minimized'}
            instantAtcViewMinimizedChange={(newValue: string) => detailCmClickFunction()}
            tailorString={tailorString}
            updateTimestamp={singleSelectedBodyMeasurement?.updateDateTime ?? new Date().toISOString()}
          />
          </Box>
        </Grid>
        <Grid item xs={12} style={{display: 'flex', justifyContent: 'space-between', margin: '3% 4% 0%'}}>
          <Typography onClick={onEditClick} className={classes.sizeOptionsBoxBadanGantiText2}>
            UBAH<EditIcon style={{height: '12px', width: '12px', marginLeft: '4px'}}/>
          </Typography>
          <Typography onClick={onUseClick}
          className={classes.sizeOptionsBoxBadanGantiText2} 
          style={{
            backgroundColor: productPurchaseStage === "ADD_TO_CART" || useZeroInstallView ? '#121212' : 'rgb(176,176,176)', 
            color: '#ffffff', 
            border: '0px solid black',
            paddingTop: productPurchaseStage === "ADD_TO_CART" || useZeroInstallView ? (isMdOrUp ? undefined : '1.9vw') : undefined,
            }}>
            {
            productPurchaseStage === "ADD_TO_CART" || useZeroInstallView ?
            "PAKAI →" :
            productPurchaseStage === "CHECKING_STOCK" ? 
            "CHECKING STOCK..." :
            "BAHAN TIDAK CUKUP" 
            }
          </Typography>
        </Grid>
      </Grid>
    </Box>
    </Box>);
  }

  return (<Box
    style={{
      position: 'relative',
      aspectRatio: '3.3',
      borderRadius: '13px',
      boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 7px 0px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      padding: isMdOrUp ? '12px 12px 4px 12px' : '3vw 3vw 1vw 3vw'
    }}
    onClick={disableActions ? openMeasDetail : undefined}
  >
    <Box onClick={disableActions ? openMeasDetail : undefined}>
      <UkuranBadanCardMini width={ isMdOrUp ? '60px' : '17vw' } fontSize={ isMdOrUp ? undefined : '1.3vw' } nama={singleSelectedBodyMeasurement?.nama ? singleSelectedBodyMeasurement.nama : 'User'}/>
    </Box>
    <Grid container style={{ width: '80%' }} onClick={disableActions ? openMeasDetail : undefined}>
      <Grid item xs={12} className={classes.sizeOptionsBoxBadanNameBox}>
        <Typography className={classes.sizeOptionsBoxBadanNameText}>Ukuran {singleSelectedBodyMeasurement?.nama ? 
        singleSelectedBodyMeasurement.nama.substring(0, 1).toUpperCase() + singleSelectedBodyMeasurement.nama.substring(1).toLowerCase() : 'User'}</Typography>
        <Typography className={classes.sizeOptionsBoxBadanTanggalText}>
          Dibuat {convertTimestampToDisplayString(singleSelectedBodyMeasurement?.updateDateTime ?? '')}
        </Typography>
      </Grid>
    </Grid>
    <Box className={classes.sizeOptionsBoxBadanGantiBox}
      onClick={openMeasDetail}>
      <IconButton
        className={classes.sizeOptionsBoxEditIconButton}
        aria-label="zoom-out">
          <EditIcon style={{height: '12px', width: '12px'}}/>
      </IconButton>
    </Box>
    {
      disableActions ? 
      null :
      <Box className={classes.sizeOptionsBoxBadanPakaiBox}>
        <Typography className={classes.sizeOptionsBoxBadanGantiText} style={{backgroundColor: '#121212', color: '#ffffff'}}>
          PAKAI
        </Typography>
      </Box>
    }
  </Box>);
}

interface SizeOptionsProps {
  clothingType: ClothingType
  fitType: FitType
  productDetail?: ProductOnUser
}

export default function SizeOptions({clothingType, fitType, productDetail}: SizeOptionsProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  const overlayViewSelection = useAppSelector(state => state.overlayMeasurementSelectionView);

  const key2 = clothingType + "-" + fitType;

  const isSignedIn = useAppSelector(state => state.account.authState === 'signedin');
  const userAccount = useAppSelector(state => state.account);

  const canMakeUkuranBadan = useAppSelector(state => state.ordersList.paidOrderCount >= 1);

  const userPrefDict = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsPreferenceDictionary);

  const userBodyMeasurementsDictionary = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  const userClothingMeasurementsDictionary = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsDictionary);
  
  let userClothingMeasurementCreationDateTimeList: string[] = userClothingMeasurementsDictionary[key2] ? Object.keys(userClothingMeasurementsDictionary[key2]).sort().reverse() : [];

  const {
    currentSelectedMeasurement,
    currentSelectedMeasurementId,
    currentSelectedMeasurementIsBody,
    key2DefaultSelectedMeasurementCanBeSet,
    key2DefaultSelectedMeasurementCanBeSetRecommended,
    currentSingleBodyMeasurementCreationDateTime,
    fitFamily
  } = getCurrentSelectedMeasurement(key2, userPrefDict, userBodyMeasurementsDictionary, userClothingMeasurementsDictionary);

  // FIT CARD SYSTEM: the resolver already falls back to the latest body card
  // within this key2's fit family, so no compatible card means no body segment.
  const singleSelectedBodyMeasurementCreationDateTime = currentSingleBodyMeasurementCreationDateTime ? currentSingleBodyMeasurementCreationDateTime.substring(5) : undefined;
  const singleSelectedBodyMeasurement = singleSelectedBodyMeasurementCreationDateTime ? userBodyMeasurementsDictionary?.[singleSelectedBodyMeasurementCreationDateTime]?.[0] : undefined;

  let defaultCreationDateTimeUsed = currentSelectedMeasurement?.creationDateTime;
  let defaultIsBodyUsed = currentSelectedMeasurementIsBody;

  const regularSizeCreationDateTime: {[key: string]: string}= {
    [RegularSizeValue.NOTSELECTED]: "",
    [RegularSizeValue.XXS]: "",
    [RegularSizeValue.XS]: "",
    [RegularSizeValue.S]: "",
    [RegularSizeValue.M]: "",
    [RegularSizeValue.L]: "",
    [RegularSizeValue.XL]: "",
    [RegularSizeValue.XXL]: "",
    [RegularSizeValue.XXXL]: "",
    [RegularSizeValue.XXXXL]: "",
    [RegularSizeValue.XXXXXL]: "",
    [RegularSizeValue.XXXXXXL]: "",
    [RegularSizeValue.XXXXXXXL]: "",
    [RegularSizeValue.XXXXXXXXL]: "",
  };

  for (var regIndex = 0; regIndex < userClothingMeasurementCreationDateTimeList.length; regIndex++) {
    const creationDateTime = userClothingMeasurementCreationDateTimeList[regIndex];
    const clothingMeasObject = userClothingMeasurementsDictionary?.[key2]?.[creationDateTime][0];
    const regularSize = clothingMeasObject.regularSize;

    if (!clothingMeasObject 
      || clothingMeasObject.sizeType !== SizeType.regular
      || !regularSize
      || regularSizeCreationDateTime[regularSize as string] !== "") {
      continue;
    }

    regularSizeCreationDateTime[regularSize as string] = creationDateTime;
  }

  if (currentSelectedMeasurement?.sizeType === SizeType.regular && 
      currentSelectedMeasurement?.regularSize &&
      regularSizeCreationDateTime?.[currentSelectedMeasurement.regularSize as string] !== "") {
    defaultCreationDateTimeUsed = regularSizeCreationDateTime[currentSelectedMeasurement.regularSize];
    defaultIsBodyUsed = false;
  }

  useEffect(() => {
    if (defaultCreationDateTimeUsed) {
      console.log("Updated parent selected measurement data");
      dispatch(setPilihUkuranDataValues({
        key2: key2,
        creationDateTime: defaultCreationDateTimeUsed,
        prefCreationDateTime: (defaultIsBodyUsed ? "body-" : "") + defaultCreationDateTimeUsed,
        isOwnedByUser: false
      }))
    }
  }, [defaultCreationDateTimeUsed, overlayViewSelection.status]); // Untuk mengupdate yang dipilih setiap kali ukuran baru dibuat atau overlay berganti

  function handleSelect(creationDateTime: string, isBody: boolean, newSelectedMeasurement: any) {

    // We update remote preferences if the user is signed in and
    // the new selected measurement is owned by the user
    let isOwnedByUser = true; // JUST SET TO TRUE FOR NOW

    dispatch(setPilihUkuranDataValues({
      key2: key2,
      creationDateTime: creationDateTime,
      prefCreationDateTime: (isBody ? "body-" : "") + creationDateTime,
      isOwnedByUser: isOwnedByUser
    }))
  }

  const postMeasurementStatus = useAppSelector(state => state.userMeasurementsList.postMeasurementStatus);

  if (postMeasurementStatus === APIRequestStatus.RequestInProgress) {
    return (<Box 
      key={'loading-bar-size'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '14px 16px 14px 16px',
        marginTop: '25vh',
        marginBottom: '10px',
        borderRadius: '20px',
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
          padding: '3.2vw 3.4vw 3.2vw 3.4vw',
          borderRadius: '5vw',
        },
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      <CircularProgress style={{
        width: '50px',
        height: '50px',
      }}/>
      <Typography>
        Loading...
      </Typography>
    </Box>);
  }

  return (
  <Box className={classes.sizeOptionsBox}>
    {/* BADAN */}
    {
      singleSelectedBodyMeasurementCreationDateTime ? 
      <Box className={classes.sizeOptionsBoxBadan} onClick={() => {
        handleSelect(singleSelectedBodyMeasurementCreationDateTime, true, singleSelectedBodyMeasurement);
        dispatch(saveLocallyClothingMeasurementPreference({
          key2: key2,
          creationDateTime: "body-" + singleSelectedBodyMeasurementCreationDateTime
        }));
        dispatch(postClothingMeasurementPreference({
          key2: key2,
          creationDateTime: "body-" + singleSelectedBodyMeasurementCreationDateTime
        }));
        dispatch(closeOverlayAndResetSelection())
      }}>
        <Box className={classes.sizeOptionsBoxSegmentBox}>
          <Typography className={classes.sizeOptionsBoxSegmentTitle}>UKURAN BADAN</Typography>
          <Typography className={classes.sizeOptionsBoxSegmentSubtext}>Untuk Semua Produk {BodyFitTypeDisplayString[fitFamily]}</Typography>
        </Box>
        <UkuranBadanSegment
        clothingType={clothingType}
        fitType={fitType}
        productDetail={productDetail}
        singleSelectedBodyMeasurement={singleSelectedBodyMeasurement}
        singleSelectedBodyMeasurementCreationDateTime={singleSelectedBodyMeasurementCreationDateTime}
        closeParentFunction={() => {
        }}
        />
      </Box>
      : null
    }
    

    {/* BADAN */}

    {/* BAJU */}

    

    <Box className={classes.sizeOptionsBoxBaju}>
      <Box className={classes.sizeOptionsBoxSegmentBox}>
        <Typography className={classes.sizeOptionsBoxSegmentTitle}>UKURAN BAJU</Typography>
        <Typography className={classes.sizeOptionsBoxSegmentSubtext}>Untuk Kategori Ini</Typography>
      </Box>
      {
        userClothingMeasurementCreationDateTimeList.map((creationDateTime, index) => {

          const clothingMeasObject = userClothingMeasurementsDictionary?.[key2]?.[creationDateTime][0];

          if (!clothingMeasObject) {
            return null;
          }

          const measName = clothingMeasObject.measurementName;
          const caraBuatString = clothingMeasObject.caraBuatString;
          const sizeType = clothingMeasObject.sizeType;

          const isSelected = overlayViewSelection?.pilihUkuranData?.creationDateTime === creationDateTime;

          if (sizeType === SizeType.personal) {
            return (<Box className={isSelected ? classes.measurementMenuItemSelected : classes.measurementMenuItem}
                key={creationDateTime}
              >
                {
                  isSelected ?
                  <img className={classes.measurementMenuItemCheck} 
                  key={'select-green'} src={process.env.PUBLIC_URL + '/green-check-select.png'} alt='green-check'/> :
                  null
                }
                <Grid container>
                  <Grid item xs={7} style={{display: 'flex', alignItems: 'center'}} 
                    onClick={(event) => {
                      handleSelect(creationDateTime, false, userClothingMeasurementsDictionary[key2][creationDateTime][0]);
                  }}>
                    <Grid container>
                      <Grid item xs={12} style={{display: 'flex', alignItems: 'center'}}>
                        <Typography className={classes.measurementMenuItemDetailContentText}>
                          Dibuat {formatTimestampSize(creationDateTime)}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{display: 'flex', alignItems: 'center'}}>
                        <Typography className={classes.measurementMenuItemMainText}>
                          {measName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={5} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    <Grid container spacing={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Box
                          style={{
                            display: 'flex',
                            gap: '5px'
                          }}
                        >
                          <IconButton
                            className={classes.sizeOptionsBoxDetailIconButton}
                            disabled={!clothingMeasObject}
                            onClick={() => {
                              dispatch(closeOverlayAndResetEditView());
                              dispatch(setValuesEditView({
                                overlayType: 'view',
                                clothingType: clothingType,
                                fitType: fitType,
                                isFullScreen: false,
                                currentMeasurementObject: clothingMeasObject,
                                productDetail: overlayViewSelection.productDetail ?? undefined,
                              }))
                              dispatch(openOverlayEditView());
                            }}aria-label="zoom-out">
                              <Typography className={classes.sizeOptionsBoxDetailText}>
                                DETAIL ⓘ
                              </Typography>
                          </IconButton>
                      
                          <IconButton
                            className={classes.sizeOptionsBoxEditIconButton}
                            disabled={!clothingMeasObject}
                            onClick={() => {
                              dispatch(closeOverlayAndResetEditView());
                              dispatch(setValuesEditView({
                                overlayType: 'edit',
                                clothingType: clothingType,
                                fitType: fitType,
                                isFullScreen: false,
                                currentMeasurementObject: clothingMeasObject,
                                productDetail: overlayViewSelection.productDetail ?? undefined,
                              }))
                              dispatch(openOverlayEditView());
                            }} aria-label="zoom-out">
                              <EditIcon style={{height: '12px', width: '12px'}}/>
                          </IconButton>
                        </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            );
          } else if (sizeType === SizeType.regular) {
            if (clothingMeasObject.regularSize && regularSizeCreationDateTime[clothingMeasObject.regularSize as string] !== creationDateTime) {
              return null;
            }
            return (<Box className={isSelected ? classes.measurementMenuItemSelected : classes.measurementMenuItem}
                key={creationDateTime}
                onClick={(event) => {
                  handleSelect(creationDateTime, false, userClothingMeasurementsDictionary[key2][creationDateTime][0]);
                }}
              >
                {
                  isSelected ?
                  <img className={classes.measurementMenuItemCheck} 
                  key={'select-green'} src={process.env.PUBLIC_URL + '/green-check-select.png'} alt='green-check'/> :
                  null
                }
                <Grid container>
                  <Grid item xs={11} style={{display: 'flex', alignItems: 'center'}}>
                  <Typography className={classes.measurementMenuItemMainText}>
                    {userClothingMeasurementsDictionary[key2][creationDateTime][0].measurementName}
                  </Typography>
                  </Grid>
                  <Grid item xs={1} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    <IconButton
                      className={classes.sizeOptionsBoxEditIconButton}
                      style={{marginRight: '-4px'}}
                      disabled={!clothingMeasObject.regularSize}
                      onClick={() => {
                        dispatch(closeOverlayAndResetEditView());
                        dispatch(setValuesEditView({
                          overlayType: 'edit',
                          clothingType: clothingType,
                          fitType: fitType,
                          isFullScreen: false,
                          currentMeasurementObject: getMeasurementObjectFromRegularSize(creationDateTime, fitType, clothingType, clothingMeasObject.regularSize ? clothingMeasObject.regularSize : RegularSizeValue.M),
                          productDetail: overlayViewSelection.productDetail ?? undefined,
                        }))
                        dispatch(openOverlayEditView());
                      }} aria-label="zoom-out">
                        <EditIcon style={{height: '12px', width: '12px'}}/>
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            );
            
          }

          return null;
        })
      }
    </Box>

    {/* BAJU */}
  </Box>)
}